// ============================================================
//  CATÁLOGO DE PELÍCULAS — JAQUECA FILMS
//  ──────────────────────────────────────────────────────────
//  CÓMO AÑADIR UNA PELÍCULA NUEVA (1 vez al año):
//  1. Copia un bloque completo { ... }, incluida la coma final.
//  2. Cambia: titulo, tituloEn, anio, ficha y sinopsis.
//  3. Elige un "tono" (color de fondo del póster provisional).
//  4. Cuando tengas el póster real, súbelo a
//     /public/images/posters/ y escribe su ruta en "poster",
//     por ejemplo: poster: "/images/posters/mi-pelicula.webp"
//     (Mientras "poster" sea null se genera el póster
//      tipográfico automático con el título.)
//     Si tienes el PÓSTER OFICIAL vertical, ponlo en
//     "posterOficial": tiene prioridad sobre el fotograma
//     y se muestra completo (sin recorte) en la ficha.
//     "trailer": enlace al tráiler en Vimeo (opcional).
//  ¡Listo! No necesitas tocar nada más del código.
// ============================================================

export const FILMS = [
    {
        slug: "amor-y-matematicas",
        titulo: "Amor y matemáticas",
        tituloEn: "Love & Mathematics",
        anio: 2022,
        ficha: "2022 · México · Color · 82 min",
        sinopsis:
            "Asfixiado por la monotonía de la vida como padre de familia, Billy Lozano añora los días en que formaba parte de la exitosa banda Equinoccio. Lejos de los escenarios y de la adoración del público, ahora pasa sus días atrapado en un mundo que algunos considerarían ideal. Tiene esposa, un hijo, una bonita casa e incluso un perro, pero aun así Billy se siente perdido. Al mismo tiempo, todos los que lo rodean exigen que se tome las cosas más en serio. Un rayo de luz llega a su vida cuando Mónica, una vecina que era fanática de su música, reaviva su chispa artística.",
        tono: "#5A1622",
        poster: "/images/stills/amor-cocina-v2.webp",
        posterAlt: "Fotograma de Amor y matemáticas: una pareja conversa frente a frente en la cocina",
        posterOficial: "/images/posters/amor-y-matematicas-poster.webp",
        posterOficialAlt: "Póster oficial de Amor y matemáticas (selección oficial TIFF): un músico a contraluz sobre el escenario",
        trailer: "https://vimeo.com/738814564",
    },
    {
        slug: "el-reino-de-dios",
        titulo: "El reino de Dios",
        tituloEn: "The Realm of God",
        anio: 2022,
        ficha: "2022 · México · Color · 73 min",
        sinopsis:
            "El mundo de Neymar se asienta en cuatro pilares: su familia, principalmente su abuela, esa figura cómplice, contadora de historias, compañera de travesuras; su amor por las carreras de caballos que cada fin de semana lo lleva al hipódromo; la religión, esa que no termina de entender pero que acepta como legado familiar mientras se prepara asistiendo juicioso a catequesis; y su propio universo imaginado de juegos callejeros abrazado por la complicidad y la alegría del trato espontáneo con cualquiera de los habitantes de su pequeño pueblo. Cuatro pilares sobre los que se cimienta y se sostiene su mundo. Cuatro columnas parejas, imprescindibles ¿estables?",
        tono: "#22301F",
        poster: "/images/stills/el-reino-de-dios.webp",
        posterAlt: "Fotograma de El reino de Dios: Neymar junto a su abuela y su familia frente a su casa de madera en el pueblo",
        posterOficial: "/images/posters/el-reino-de-dios-poster.webp",
        posterOficialAlt: "Póster oficial de El reino de Dios (Berlinale Generation 2022): Neymar camina por un camino de terracería",
        trailer: "https://vimeo.com/1006980360",
    },
    {
        slug: "el-camino-de-sol",
        titulo: "El camino de Sol",
        tituloEn: "Sol's Journey",
        anio: 2021,
        ficha: "2021 · México · Color · 78 min",
        sinopsis:
            "Con apenas siete años de edad, el pequeño Christian es secuestrado a las afueras de su unidad habitacional. Tras percatarse de la indiferencia y la lentitud de la justicia para atender su caso, Sol empieza una búsqueda frenética para recuperar a su hijo.",
        tono: "#4A3416",
        poster: "/images/stills/camino-calle-v2.webp",
        posterAlt: "Fotograma de El camino de Sol: dos personas conversan cara a cara en una calle de la ciudad",
        posterOficial: "/images/posters/el-camino-de-sol-poster.webp",
        posterOficialAlt: "Póster oficial de El camino de Sol, una película de Claudia Sainte-Luce",
        trailer: "https://vimeo.com/451669356",
    },
    {
        slug: "la-caja-vacia",
        titulo: "La caja vacía",
        tituloEn: "The Empty Box",
        anio: 2016,
        ficha: "2016 · México – Francia · Color · 101 min",
        sinopsis:
            "Debido a su condición de salud, Toussaint tiene que ir a vivir con Jazmín, su hija. Toussaint es un hombre que no es capaz de echar raíces en ninguno de los lugares en los que ha vivido. No fue un padre amoroso y es un completo desconocido para Jazmín. A través de esta convivencia obligada, Toussaint armará el rompecabezas de su pasado.",
        tono: "#23262E",
        poster: "/images/stills/la-caja-vacia.webp",
        posterAlt: "Fotograma de La caja vacía: Toussaint, con la frente vendada, junto a su hija Jazmín frente al espejo",
        posterOficial: "/images/posters/la-caja-vacia-poster.webp",
        posterOficialAlt: "Póster oficial de La caja vacía, selección del Festival Internacional de Cine de Toronto (TIFF)",
        trailer: "https://vimeo.com/203357084",
    },
    {
        slug: "los-insolitos-peces-gato",
        titulo: "Los insólitos peces gato",
        tituloEn: "The Amazing Catfish",
        anio: 2013,
        ficha: "2013 · México – Francia · Color · 92 min",
        sinopsis:
            "Claudia, joven solitaria que trabaja en un supermercado, termina en urgencias con apendicitis. Ahí conoce a Martha, la mujer de la cama de a lado. Martha invita a Claudia a su casa y se vuelven amigas. Cuando Claudia descubre que la salud de Martha se agrava, comienza a crear una conexión con sus hijos.",
        tono: "#3A1B2E",
        poster: "/images/stills/los-insolitos-peces-gato.webp",
        posterAlt: "Fotograma de Los insólitos peces gato: una mujer y un niño platican acostados en la cama",
        posterOficial: "/images/posters/los-insolitos-peces-gato-poster.webp",
        posterOficialAlt: "Póster oficial de Los insólitos peces gato: la familia junto a un vocho amarillo en la carretera del desierto",
        trailer: "https://vimeo.com/478515973",
    },
];

// Galería: fotografías reales de rodaje (detrás de cámaras).
// Para añadir más, súbelas a /public/images/galeria/ y agrega
// entradas aquí con alt descriptivo (importante para SEO).
export const GALLERY = [
    { src: "/images/galeria/estudio-mezcla.webp", alt: "Equipo de Jaqueca Films en la sala de mezcla de sonido durante la postproducción", caption: "Mezcla de sonido · Postproducción" },
    { src: "/images/galeria/set-interior.webp", alt: "Ensayo con actores en locación interior durante un rodaje", caption: "Ensayo en locación" },
    { src: "/images/galeria/exteriores-bn.webp", alt: "Crew de rodaje descansando sobre una tubería en exteriores, fotografía en blanco y negro", caption: "Rodaje en exteriores · B/N" },
    { src: "/images/galeria/rodaje-playa.webp", alt: "Filmación de una escena en la playa con actrices en el mar", caption: "Rodaje en la playa" },
    { src: "/images/galeria/camara-red.webp", alt: "Directora y equipo revisando el monitor de una cámara RED en exteriores", caption: "Cámara RED · En set" },
    { src: "/images/galeria/set-rojo.webp", alt: "Equipo de filmación trabajando en un set interior iluminado con luz roja", caption: "Set interior · Luz roja" },
    { src: "/images/galeria/rodaje-calle.webp", alt: "Rodaje en exteriores urbanos con cámara y equipo en la calle", caption: "Rodaje en la calle" },
    { src: "/images/galeria/crew-bn.webp", alt: "Fotografía de grupo del crew completo de producción en blanco y negro", caption: "El crew · B/N" },
    { src: "/images/galeria/set-comedor.webp", alt: "Preparación de una escena en un comedor con actores, directora y equipo de cámara", caption: "Preparación de escena · Interior" },
];

// Logotipo original de Jaqueca Films (subido por el cliente)
export const LOGO = "/images/logo-jaqueca.webp";
export const LOGO_OVAL = "/images/logo-oval.webp";
// Versión en tinta clara para fondos oscuros (footer)
export const LOGO_CLARO = "/images/logo-jaqueca-claro.webp";

export const EMAIL = "info@jaquecafilms.com";

export const SOCIALS = [
    { label: "Facebook", url: "https://facebook.com/jaquecafilms" },
    { label: "X / Twitter", url: "https://twitter.com/jaquecafilms" },
    { label: "Flickr", url: "https://www.flickr.com/photos/jaquecafilms/" },
    { label: "Vimeo", url: "https://vimeo.com/user42034817" },
];
